import {
	EmpresasService,
	AmostrasService,
	ConservacaoService,
	ConvenioService,
	ArquivosTemporariosService
} from "../../services";
import SolicitanteService from "../../services/SolicitanteService";
import { CODIGO_EMPRESA_IHP } from '../../shared/utils/Constantes'
import { baixarArquivo } from "../../shared/utils/RequestUtil";

class CadastroAmostrasManager {
	async listarEmpresas() {
		return await EmpresasService.listarEmpresas().then((res) => {
			let resposta = [];

			if (res && res.data) {
				res.data.forEach((item) => {
					if (item.codigo === CODIGO_EMPRESA_IHP)
						resposta = resposta.concat(item);
				});

				res.data.forEach((item) => {
					if (item.codigo !== CODIGO_EMPRESA_IHP)
						resposta = resposta.concat(item);
				});
			}

			return resposta;
		})
	}

	async listarTiposAmostra() {
		return await AmostrasService.listarTipos().then((res) => {
			return res && res.data
		})
	}

	async listarTiposConservacao() {
		return await ConservacaoService.listarTipos().then((res) => {
			return res && res.data
		})
	}

	async listarConvenioPorLaboratorio(codLaboratorio) {
		return await ConvenioService.listarConvenioPorLaboratorio(codLaboratorio).then((res) => {
			return res && res.data;
		})
	}

	async cadastrarAmostra(dados) {
		return await AmostrasService.cadastrarAmostra(dados, true).then((res) => {
			return res && res.data;
		})
	}

	async enviarArquivoTemporario(arquivo) {
		return await ArquivosTemporariosService.enviar(arquivo).then((res) => {
			return res && res.data;
		});
	}

	async baixarArquivoTemporario(guid, nomeArquivo) {
		const resposta = await ArquivosTemporariosService.baixar(guid);
		if (!resposta || !resposta.data) return;

		baixarArquivo(resposta, nomeArquivo);
	}

	async excluirArquivoTemporario(guid) {
		return await ArquivosTemporariosService.excluir(guid).then((res) => {
			return res;
		});
	}

	async listarSolicitantes(nomeOuCodigo, ufConselho) {
		try {
			return await SolicitanteService.listarSolicitantes(nomeOuCodigo, ufConselho)
				.then(resposta => {
					return { lista: resposta.data };
				})
				.catch(error => {
					if (error.response && error.response.status !== 404) {
						return {
							erro: true
						};
					}
				});
		} catch (error) {
			console.log("error :", error);
		}
	}
}

export default new CadastroAmostrasManager()